import * as React from "react";
import { forwardRef } from "react";
const SnowflakeIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M12 2.985a.75.75 0 0 1 .75.75v2.473l.803-.803a.75.75 0 0 1 1.061 1.061L12.75 8.329v3.104l2.703-1.561.679-2.529a.75.75 0 1 1 1.449.388l-.291 1.081 2.132-1.23a.75.75 0 0 1 .75 1.299l-2.142 1.235 1.097.295a.75.75 0 0 1 .53.918.75.75 0 0 1-.918.53l-2.546-.682-2.699 1.558 2.699 1.559 2.546-.681a.75.75 0 0 1 .918.53.75.75 0 0 1-.53.918l-1.097.293 2.142 1.237a.75.75 0 0 1-.75 1.299l-2.132-1.231.29 1.082a.75.75 0 0 1-.53.918.75.75 0 0 1-.918-.53l-.679-2.53-2.703-1.561v3.105l1.863 1.863a.75.75 0 0 1-1.061 1.061l-.803-.803v2.473a.75.75 0 1 1-1.5 0v-2.461l-.791.791a.75.75 0 0 1-1.061-1.061l1.852-1.852V14.03l-2.688 1.552-.682 2.546a.75.75 0 1 1-1.449-.388l.293-1.097-2.14 1.236a.75.75 0 0 1-.75-1.299l2.131-1.231-1.081-.289a.75.75 0 0 1-.53-.918.75.75 0 0 1 .919-.53l2.529.677 2.692-1.555-2.692-1.554-2.529.678a.75.75 0 0 1-.919-.53.75.75 0 0 1 .53-.918l1.08-.291-2.13-1.229a.75.75 0 0 1 .75-1.299l2.141 1.235L6.43 7.73a.75.75 0 1 1 1.449-.388l.681 2.544 2.689 1.553V8.317L9.398 6.466a.75.75 0 0 1 1.061-1.061l.791.791V3.735a.75.75 0 0 1 .75-.75z"
}));
const ForwardRef = forwardRef(SnowflakeIcon);
export default ForwardRef;